export default __webpack_public_path__ + "static/media/icon-audio-library.4e22669b.png";